import { render, staticRenderFns } from "./ProgressFake.vue?vue&type=template&id=f10d475e&scoped=true"
var script = {}
import style0 from "./ProgressFake.vue?vue&type=style&index=0&id=f10d475e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10d475e",
  null
  
)

export default component.exports